module.exports = __webpack_public_path__ + "static/img/pic5.60d4433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/pic5.png
// module id = fsZI
// module chunks = 1